import AWS from 'aws-sdk';

AWS.config.region = 'us-west-2';
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: 'us-west-2:dd215d9b-f560-4edd-9de6-ed6dd66e243e',
});

export default AWS;
